import React, { useState } from "react";
import { Application, ApplicationService } from "../applications";
import { Payment } from "./";

import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { PayPalPayment } from "./PayPalPayment";

export const RegistrationPayment = () => {
	const [application] = useState(new Application());

	const [applicationFound, setApplicationFound] = useState(false);
	const [existingEmail, setExistingEmail] = useState("");
	const [existingApplicationId, setExistingApplicationId] = useState();
	const [existingError, setExistingError] = useState("");
	const [paymentCompleted, setPaymentCompleted] = useState(false);
	const [errors, setErrors] = useState<string | null>(null);

	const applicationService = new ApplicationService();

	const checkExisting = async () => {
		setExistingError("");
		if (!existingApplicationId) {
			setExistingError("Please enter your application ID.");
			return;
		}

		if (!existingEmail) {
			setExistingError(
				"Please enter the email address you used for your application.",
			);
			return;
		}

		const app = await applicationService.getApplicationByApplicationId(
			String(existingApplicationId),
			existingEmail,
			application,
		);

		if (app) {
			setApplicationFound(true);
		}

		if (app === false) {
			setExistingError(
				"Application could not be found using the information provided.",
			);
		}
	};

	const handlePayment = (pmt: Payment) => {
		pmt.application = application;
		applicationService.submitProofOfPayment(pmt);
		setPaymentCompleted(true);
	};

	const handlePaymentError = () => {
		setErrors("Payment could not be processed.");
	};

	let output;
	if (applicationFound && !paymentCompleted) {
		output = (
			<Row className="mb-4">
				<Col>
					<p>
						A non-refundable registration fee of $2,000 JMD or{" "}
						<strong>$16 USD</strong> is required* to complete your
						application for a UCC Executive Certificate Course.
					</p>
					<p>
						To pay your application fee online you may pay directly
						using a Visa Debit Card, Visa Credit Card or MasterCard
						or use PayPal.
					</p>
					{errors ? <Alert variant="danger">{errors}</Alert> : ""}

					{paymentCompleted ? (
						<h4 className="mb-4 mt-4">
							Thank you! Your payment has been submitted.
						</h4>
					) : (
						<PayPalPayment
							type="Registration Fee"
							amount={16.0}
							onPaymentSuccess={handlePayment}
							onPaymentError={handlePaymentError}
						/>
					)}
				</Col>
			</Row>
		);
	} else if (paymentCompleted) {
		output = (
			<>
				<h3>Payment Submitted</h3>
				<p className="mb-4 mt-4">
					Thank you, your registration fee has been submitted!
				</p>
			</>
		);
	} else {
		output = (
			<Row>
				<Col xs={12}>
					<p style={{ fontSize: 20, marginBottom: 20 }}>
						Use this form to submit the registration fee for your
						application. Enter the email address used when filling
						out your application, along with the application id
						provided.
					</p>
				</Col>
				<Col xs={12}>
					<Form.Group controlId="existingApplicationId">
						<Form.Label>Application ID</Form.Label>
						<Form.Control
							size="lg"
							onChange={(event: any) =>
								setExistingApplicationId(event.target.value)
							}
						/>
					</Form.Group>
				</Col>

				<Col xs={12}>
					<Form.Group controlId="existingEmail">
						<Form.Label>Email</Form.Label>
						<Form.Control
							size="lg"
							onChange={(event: any) =>
								setExistingEmail(event.target.value)
							}
						/>
					</Form.Group>

					<Button
						variant="primary"
						size="lg"
						className="float-right btn-next"
						onClick={checkExisting}
					>
						Find Application
					</Button>
				</Col>
			</Row>
		);
	}

	return (
		<div className="container" id="ced-application">
			<div className="stepzilla-well">
				{existingError ? (
					<Alert variant="danger">{existingError}</Alert>
				) : null}
				<h1 className="mb-4">Registration Fee</h1>
				{output}
			</div>
		</div>
	);
};
